<template>
  <el-dialog
    title="文章详情"
    :visible.sync="dialogVisible"
    width="1200px"
    @close="onClose"
  >
    <el-form
      label-width="120px"
      style="max-height: calc(100vh - 280px);overflow-y: auto;padding: 15px"
      v-loading="loading"
    >
      <el-form-item label="内容标题：">
        <div class="box-value">{{ form.Title || "-" }}</div>
      </el-form-item>
      <el-form-item label="文章分类：">
        <div class="box-value">{{ form.TypeName || "-" }}</div>
      </el-form-item>
      <el-form-item label="封面图：">
        <div class="box-value">
          <img
            v-if="form.HeadImage"
            style="height: 100px;width: 100px;margin-bottom: 10px;"
            :src="form.HeadImage"
          />
          <div v-else>-</div>
        </div>
      </el-form-item>
      <el-form-item label="附件：">
        <div v-if="form.File.length > 0">
          <div class="box-value" v-for="(x, i) in form.File" :key="i">
            <a href="javascript:void(0);" @click="onDownload(x.url, x.name)">{{
              x.name
            }}</a>
          </div>
        </div>
        <div class="box-value" v-else>-</div>
      </el-form-item>
      <el-form-item label="摘要：">
        <div class="box-value">{{ form.Describe || "-" }}</div>
      </el-form-item>
      <el-row>
        <el-col :span="8">
          <el-form-item label="发布时间：" prop="ReleaseTime">
            <div class="box-value">
              {{ (form.ReleaseTime * 1000) | formatDate }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="作者：" prop="Publisher">
            <div class="box-value">{{ form.Publisher || "-" }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="来源：" prop="PublishSource">
        <div class="box-value">{{ form.PublishSource || "-" }}</div>
      </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="发布形式：" prop="ReleaseStatus">
            <div class="box-value">
              {{ form.ReleaseStatus === 0 ? "网页形式" : "链接形式" }}
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item
        label="链接地址："
        prop="LinkUrl"
        v-if="form.ReleaseStatus === 1"
      >
        <div class="box-value">{{ form.LinkUrl || "-" }}</div>
      </el-form-item>
      <el-form-item
        label="内容："
        prop="Abstract"
        v-if="form.ReleaseStatus === 0"
      >
        <div
          style="border: 1px solid #e6e6e6;padding: 20px"
          v-html="form.Abstract"
        />
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import api from "@/modules/zjrc/api";
import { saveAs } from "file-saver";

export default {
  name: "edit",
  props: {},
  data() {
    return {
      dialogVisible: false,
      form: {
        Title: "",
        TypeName: "",
        HeadImage: "",
        Describe: "",
        PublishSource: "",
        ReleaseTime: undefined,
        Publisher: "",
        Sort: undefined,
        ReleaseStatus: undefined,
        LinkUrl: "",
        Abstract: "",
        File: [],
      },
      loading: true
    };
  },
  methods: {
    onDownload(url, name) {
      saveAs(url, name);
    },
    create(id) {
      const vm = this;
      vm.dialogVisible = true;
      const param = {
        id: id,
      };
      vm.loading = true
      api.QueryNewsById(param).then((res) => {
        if (res.data.Code === 0) {
          vm.form = res.data.Data;
          vm.form.TypeName = vm.form.TypeName.replace(/,/gi, " / ");
          if (vm.form.File) {
            vm.form.File = JSON.parse(this.form.File);
          } else {
            vm.form.File = [];
          }
        }
      }).finally(()=>{
        vm.loading = false
      })
    },
    onClose() {
      const vm = this;
      vm.dialogVisible = false;
      vm.form = {
        Title: "",
        TypeName: "",
        HeadImage: "",
        Describe: "",
        PublishSource: "",
        ReleaseTime: undefined,
        Publisher: "",
        Sort: undefined,
        ReleaseStatus: undefined,
        LinkUrl: "",
        Abstract: "",
        File: [],
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.box-value {
  border-bottom: 1px dashed #e6e6e6;
}
</style>
